import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Menu } from '@fiverr-private/orca';
import If from '../../../../lib/If';
import { rollouts, user } from '../../../../PropTypes';
import {
    SellerPromotedGigsLink,
    SellerBusinessLink,
    SellerContactsLink,
    KickstartProgramPageLink,
    SellerPlusLink,
    SellerMarketingToolsLink,
    SellerSPForumLink,
} from '../../../SellerLinks';
import SellerDropdown from '../../SellerDropdown';
import SellerAchievementsLink from '../../Links/SellerOverview';
import TeamAccountsLink from '../../Links/TeamAccounts';
import { SellerReferralsLink } from '../../Links/SellerReferrals';
import { KICKSTART_STATUS, SELLER_PLUS_STATUS, SELLER_PLUS_TIER } from '../../../../constants';
import GroupHeader from '../GroupHeader';

const GrowthAndMarketing = (props, { user, rollouts }) => {
    const isSellerPlusEligible = user.sellerPlus?.status === SELLER_PLUS_STATUS.ELIGIBLE;
    const isSellerPlusEnrolled = user.sellerPlus?.status === SELLER_PLUS_STATUS.ENROLLED;
    const isPremium = user.sellerPlus?.tier === SELLER_PLUS_TIER.PREMIUM;
    const isSellerPlusBasic = user.sellerPlus?.tier === SELLER_PLUS_TIER.BASIC;
    const sellerPlusLabelKey = isSellerPlusEnrolled ? 'header.program_page' : 'header.link_label.program_benefits';
    const isEnrolledToKickstartProgram = user.kickstart?.status === KICKSTART_STATUS.ENROLLED;
    const inDragonsSellerReferralsDashboardRollout = rollouts.inDragonsSellerReferralsDashboardRollout;
    const inDragonsSellerReferralsFlowRollout = rollouts.inDragonsSellerReferralsFlowRollout;

    const isATeamOwner = user.teamAccount?.ownerId === user.id && user.teamAccount?.slug;
    const kickstartProgramPageLabelKey = isEnrolledToKickstartProgram
        ? 'header.program_page'
        : 'header.link_label.program_benefits';

    return (
        <SellerDropdown
            triggerLabel={<I18n k="header.submenu.growth_and_marketing" />}
            menu={
                <Menu className="seller-menu">
                    {/* Seller plus program section */}
                    <If condition={(isSellerPlusEligible && !isEnrolledToKickstartProgram) || isSellerPlusEnrolled}>
                        <GroupHeader labelKey="header.seller_plus" />
                        <If condition={!isSellerPlusBasic}>
                            <Menu.Item>
                                <SellerPlusLink labelKey={sellerPlusLabelKey} sellerId={user.id} />
                            </Menu.Item>
                        </If>
                        <If condition={isSellerPlusBasic}>
                            <Menu.Item>
                                <KickstartProgramPageLink labelKey={sellerPlusLabelKey} sellerId={user.id} />
                            </Menu.Item>
                        </If>

                        <If condition={isSellerPlusEnrolled}>
                            <Menu.Item>
                                <SellerMarketingToolsLink sellerId={user.id} />
                            </Menu.Item>
                        </If>
                        <If condition={isSellerPlusEnrolled && isPremium}>
                            <Menu.Item>
                                <SellerSPForumLink sellerId={user.id} />
                            </Menu.Item>
                        </If>
                        <Menu.Divider />
                    </If>
                    {/* Kickstart program section */}
                    <If condition={isEnrolledToKickstartProgram}>
                        <GroupHeader labelKey="header.kickstart" />
                        <Menu.Item>
                            <KickstartProgramPageLink labelKey={kickstartProgramPageLabelKey} sellerId={user.id} />
                        </Menu.Item>
                        <Menu.Divider />
                    </If>
                    <If condition={!!user.promotedAdsVisible}>
                        <Menu.Item>
                            <SellerPromotedGigsLink sellerId={user.id} sellerUsername={user.username} />
                        </Menu.Item>
                    </If>
                    <If condition={!!user.isPro}>
                        <Menu.Item>
                            <SellerBusinessLink sellerId={user.id} />
                        </Menu.Item>
                    </If>
                    <Menu.Item>
                        <SellerAchievementsLink sellerId={user.id} />
                    </Menu.Item>
                    <If condition={isATeamOwner}>
                        <Menu.Item>
                            <TeamAccountsLink teamSlug={user.teamAccount?.slug} />
                        </Menu.Item>
                    </If>
                    <If condition={inDragonsSellerReferralsDashboardRollout && inDragonsSellerReferralsFlowRollout}>
                        <Menu.Item>
                            <SellerReferralsLink />
                        </Menu.Item>
                    </If>
                    <Menu.Item>
                        <SellerContactsLink sellerId={user.id} />
                    </Menu.Item>
                </Menu>
            }
        />
    );
};

GrowthAndMarketing.contextTypes = {
    user,
    rollouts,
};

export default GrowthAndMarketing;
